import React from 'react';
import './logo.css';

const Logo = () => {
  return ( 
    <div className="logo">
      <h1>Harrington<span className='greentext'>&</span> Associates</h1>
    </div>
  );
}
 
export default Logo;